export default "__VITE_ASSET__48967d1d__"